import { useContext } from "react";
import { ExonnHubContext } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHubProvider.tsx";

export const useExonnHubContext = () => {
  const context = useContext(ExonnHubContext);
  if (!context) {
    throw new Error("useExonnHubContext must be used withing ExonnHubProvider");
  }
  return context;
};
